import { render, staticRenderFns } from "./StepNavigation.vue?vue&type=template&id=bbf26b50&"
import script from "./StepNavigation.vue?vue&type=script&lang=ts&"
export * from "./StepNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports